import { ConnectorType } from 'apollo/generated/client-operations';
import avigilonMark from 'assets/images/avigilon-mark.svg';
import type { ConnectorCatalogEntry } from 'containers/jobsiteConfiguration/tabs/connectors/drawers/connectorCatalogEntry';
import { AvigilonVideoConnectorDetailsDrawer } from './AvigilonVideoConnectorDetailsDrawer';
import { AvigilonVideoConnectorSetupDrawer } from './AvigilonVideoConnectorSetupDrawer';

export const avigilonVideoConnectorCatalogEntry: ConnectorCatalogEntry = {
  type: ConnectorType.AvigilonVideo,
  mark: avigilonMark,
  SetupDrawer: AvigilonVideoConnectorSetupDrawer,
  DetailsDrawer: AvigilonVideoConnectorDetailsDrawer,
};
